import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=0ba8860c&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=ts&"
export * from "./Notification.vue?vue&type=script&lang=ts&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=0ba8860c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8860c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba8860c')) {
      api.createRecord('0ba8860c', component.options)
    } else {
      api.reload('0ba8860c', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=0ba8860c&scoped=true&", function () {
      api.rerender('0ba8860c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/notification/Notification.vue"
export default component.exports